export enum EmojiCategory {
    Smileys = 'Smileys & People',
    Animals = 'Animals & Nature',
    Food = 'Food & Drink',
    Activities = 'Activities',
    Travel = 'Travel & Places',
    Objects = 'Objects',
    Symbols = 'Symbols',
    Flags = 'Flags',
    Component = 'Component',
}

export enum EmojiFilter {
    Group = 'Group',
    Name = 'Name',
    NameAndAlias = 'NameAndAlias',
    NameGroup = 'NameGroup',
    NameGroupSubgroup = 'NameGroupSubgroup',
    NameGroupSubgroupGlyph = 'NameGroupSubgroupGlyph',
    All = 'All',
}

export interface EmojiCollectionData {
    glyph: string;
    name: string;
    shortName: string;
    // These props are currently not available via `CharacterSet.filter()`.
    edition?: number;
    aliases?: string[];
}

export type EmojiCollection = {
    [key in EmojiCategory]?: EmojiCollectionData[];
};

export type EmojiCharacterSetFilterData = [
    EmojiCollectionData['glyph'],
    EmojiCollectionData['name'],
    EmojiCollectionData['shortName'],
];
